export default __webpack_public_path__ + "static/media/settings-icon.604abb67.svg";